/*eslint-disable react/no-set-state*/
import React, {PropTypes} from 'react';
import '../../styles/common/Error.css';

class Error extends React.Component {
  constructor(props, context) {
    super(props, context);
  }
  render() {
    let cssClasses = `falert alert alert-danger`;
    return (
      <div
        id="errorContainer"
        tabIndex="0"
        className={cssClasses}
        role="alert"
        hidden={!this.props.error}>
        <span className="sr-only">Error:</span>
        <div className="first-line">{this.props.error}</div>
      </div>
    );
  }
}

Error.propTypes = {
  error: PropTypes.string
};

export default Error;



/** WEBPACK FOOTER **
 ** ./src/components/common/Error.js
 **/